import type { TileColor, FontPreset, LayoutPreset, DefaultPresetId } from "./types";

export const TILE_COLORS: Record<TileColor, string> = {
  red: "#ef4444",
  blue: "#3b82f6",
  green: "#22c55e",
  orange: "#f97316",
  purple: "#a855f7",
  cyan: "#06b6d4",
  amber: "#f59e0b",
  teal: "#14b8a6",
  rose: "#f43f5e",
  indigo: "#6366f1"
};

export const FONT_PRESETS: FontPreset[] = [
  {
    id: "standard",
    name: "Standard",
    description: "Comfortable reading, standard spacing"
  },
  {
    id: "war-room",
    name: "War Room",
    description: "Dense, high info, large spacing"
  }
];

export const DEFAULT_PRESET_IDS = new Set<DefaultPresetId>(["hq-default", "war-room"]);

export function isDefaultPreset(id: string): id is DefaultPresetId {
  return DEFAULT_PRESET_IDS.has(id as DefaultPresetId);
}

export const LAYOUT_PRESETS: LayoutPreset[] = [
  {
    id: "hq-default",
    name: "HQ Default",
    columns: 4,
    fontPreset: "standard",
    tiles: [
      { id: "timeline", colSpan: 1, rowSpan: 3, visible: true },
      { id: "description", colSpan: 1, rowSpan: 2, visible: true },
      { id: "media", colSpan: 1, rowSpan: 2, visible: true },
      { id: "documents", colSpan: 1, rowSpan: 2, visible: true },
      { id: "notes", colSpan: 1, rowSpan: 2, visible: true },
      { id: "checklists", colSpan: 1, rowSpan: 2, visible: true },
      { id: "location", colSpan: 1, rowSpan: 2, visible: true },
      { id: "ownership", colSpan: 1, rowSpan: 2, visible: true },
      { id: "contacts", colSpan: 1, rowSpan: 2, visible: true },
      { id: "budget", colSpan: 2, rowSpan: 2, visible: true },
      { id: "marketing", colSpan: 1, rowSpan: 2, visible: true }
    ]
  },
  {
    id: "war-room",
    name: "War Room",
    columns: 3,
    fontPreset: "war-room",
    tiles: [
      { id: "media", colSpan: 1, rowSpan: 2, visible: true },
      { id: "notes", colSpan: 1, rowSpan: 2, visible: true },
      { id: "budget", colSpan: 1, rowSpan: 2, visible: true },
      { id: "documents", colSpan: 1, rowSpan: 2, visible: true },
      { id: "checklists", colSpan: 1, rowSpan: 2, visible: true },
      { id: "ownership", colSpan: 1, rowSpan: 2, visible: true },
      { id: "description", colSpan: 1, rowSpan: 2, visible: true },
      { id: "timeline", colSpan: 1, rowSpan: 3, visible: true },
      { id: "contacts", colSpan: 1, rowSpan: 2, visible: true },
      { id: "location", colSpan: 1, rowSpan: 2, visible: false },
      { id: "marketing", colSpan: 1, rowSpan: 2, visible: false }
    ]
  }
];
